export default __webpack_public_path__ + "static/header.dibk-644a28d3193a32ffd92ba0706dac2dd0.jpg";